
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import React from "react";
import Layout from "@/components/core/Layout";
import FeatureSection from "@/components/features/FeatureSection";
import FeatureBanner from "@/components/features/FeatureBanner";
import FeatureDescription from "@/components/features/FeatureDescription";

const ALL_FEATURES = ["chat", "phone", "audio-call", "video-call", "callback", "appointment", "0900"];
const IMAGE_SIZES = {
  chat: [694, 455],
  appointment: [804, 426],
  "video-call": [744, 448],
};

const Features = () => (
  <Layout>
    <FeatureBanner />
    <div className="container">
      <FeatureDescription />
      {ALL_FEATURES.map((feature, index) => (
        <FeatureSection
          key={feature}
          feature={feature}
          textLeft={index % 2 === 1}
          imageWidth={IMAGE_SIZES[feature] ? IMAGE_SIZES[feature][0] : undefined}
          imageHeight={IMAGE_SIZES[feature] ? IMAGE_SIZES[feature][1] : undefined}
        />
      ))}
    </div>
  </Layout>
);

export default Features;


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/features',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  